export default {
	sec_10: {
		title: {
			one: 'Payment ',
			two: 'method',
		},
		desc: {
			one: 'Customers can pay at merchants',
			two: 'using just their mobile phones.',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_11: {
		one: {
			title: {
				one: 'JP WORLD Pay paid to the merchant',
			},
			desc: {
				one: 'Settlement by affiliate store or settlement for all affiliate stores',
			},
		},
		two: {
			title: {
				one: 'The settled JP WORLD Pay is fixed and',
				two: 'can be withdrawn at any time.',
			},
		},
	},
};
